<template>
  <div :class="{'plat-sliders': true, 'single-slide': isSingleSlide}">
    <div class="margin-general content">
      <div class="portafolio-items">
        <h2>
          {{ $t(titleSection) }}
        </h2>
        <p class="desc">{{ $t(descriptionSection) }}</p>
        <div v-if="cardsPlatform && cardsPlatform.length > 0" class="buttons">
          <p v-for="(item, index) in cardsPlatform"
            :key="index"
            :class="index === activeSlide ? 'body-6-bold' : 'body-6'"
            class="linksText"
            @click="slideTo(index)"
          >
            {{ $t(item.name) }}
          </p>
        </div>
      </div>
      <div class="carousel-container" :class="className">
        <swiper
          :modules="modules"
          :slidesPerView="1.2"
          :spaceBetween="15"
          :navigation="true"
          :loop="true"
          :initialSlide="initialSlide"
          class="slidePortafolio"
          @swiper="setSwiperRef"
          @slideChange="onSlideChange" 
          effect="slide"
          :breakpoints="{
            '1200': {
              slidesPerView: slidesPerView,
              spaceBetween: spaceBetween,
            },
            '850': {
              slidesPerView: 1.8,
              spaceBetween: 15,
              slidesPerGroup: 1,
            },
            '769': {
              slidesPerView: 1.2,
              spaceBetween: 15,
              slidesPerGroup: 1,
            },
            '569': {
              slidesPerView: 2.1,
              spaceBetween: 15,
              slidesPerGroup: 1,
            },
            '500': {
              slidesPerView: 1.8,
              spaceBetween: 15,
              slidesPerGroup: 1,
            },
            '400': {
              slidesPerView: 1.4,
              spaceBetween: 15,
              slidesPerGroup: 1,
            },
            '376': {
              slidesPerView: 1.1,
              spaceBetween: 15,
              slidesPerGroup: 1,
            },
          }"
        >
          <swiper-slide
            class="swiper-slide"
            v-for="(slide, j) in slider"
            :key="j"
          >
          <NuxtImg
            :src="slide.imgBackground"
            :width="slide.imgWidth"
            :height="slide.imgHeight"
            :alt="slide.imgAlt || 'Imagen de fondo'"
            class="img-background"
            format="webp"
            quality="85"
            loading="lazy"
            decoding="async"
          />
            <img
              v-if="slide.img"
              :src="slide.img"
              :alt="slide.alt"
              class="img-card"
            />
            <div class="icon" v-if="slide.icon">
              <img :src="slide.icon" :alt="slide.alt" />
            </div>
            <h4>{{ $t(slide.title) }}</h4>
            <!-- <p>{{ $t(slide.description) }}</p> -->
            <ul>
              <li v-for="item in slide.description" :key="item">
                {{ $t(item) }}
              </li>
            </ul>
          </swiper-slide>
        </swiper>
      </div>

      <div class="noSliderMobile" v-if="noSliderMobile">
        <div
          class="cardMobile"
          v-for="(slide, j) in slider"
          :key="j"
        >
          <NuxtImg
            :src="slide.imgBackground"
            :width="slide.imgWidth"
            :height="slide.imgHeight"
            :alt="slide.alt || 'Imagen de fondo'"
            class="img-background"
            format="webp"
            quality="85"
            loading="lazy"
            decoding="async"
            style="width: 100%; height: auto;"
          />
          <div class="icon" v-if="slide.icon">
            <img :src="slide.icon" alt="" />
          </div>
          <h4>{{ $t(slide.title) }}</h4>
          <ul>
            <li v-for="item in slide.description" :key="item">
              {{ $t(item) }}
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, computed } from "vue";
import { Swiper, SwiperSlide } from "swiper/vue";
import { Pagination, Navigation, Virtual, Autoplay } from "swiper/modules";

// 1. Props: Se definen con defineProps
const props = defineProps({
  titleSection: String,
  descriptionSection: String,
  cardsPlatform: Array, // antes 'cards'
  slider: Array,
  slidesPerView: Number,
  spaceBetween: Number,
  noSliderMobile: {
    default: false,
    type: Boolean,
  },
  btn: {
    default: true,
    type: Boolean,
  },
  className: {
    default: "",
    type: String,
  },
});

const selectedItem = ref({});
const currentIndex = ref(0);
const swiperRef = ref(null);
const activeSlide = ref(0);
const initialSlide = 0;
const modules = [Pagination, Navigation, Virtual, Autoplay];

const isSingleSlide = computed(() => {
  return Array.isArray(props.slider) && props.slider.length === 1;
});

const setSwiperRef = (swiperInstance) => {
  swiperRef.value = swiperInstance;
};

const onSlideChange = () => {
  if (swiperRef.value) {
    activeSlide.value = swiperRef.value.realIndex;
  }
};

const slideTo = (index) => {
  if (swiperRef.value) {
    swiperRef.value.slideToLoop(index);
  }
};

onMounted(() => {
  if (props.cardsPlatform && props.cardsPlatform.length > 0) {
    selectedItem.value = props.cardsPlatform[0];
  }
  activeSlide.value = initialSlide;
});
</script>